import { Button } from '@mui/material';
import { useContext } from 'react';
import { Form } from 'react-final-form';
import { useNavigate } from 'react-router-dom';

import CommentAPI from '../../../../api/CommentAPI';
import {
    ProcessesContext,
    ProcessesContextType,
} from '../../../../contexts/processes';
import {
    SessionContext,
    SessionContextType,
} from '../../../../contexts/session';
import {
    UserActivityContext,
    UserActivityContextType,
} from '../../../../contexts/userActivity';
import { Comment } from '../../../../models/Comment';
import { PollRecord } from '../../../../models/Poll';
import { RoutePaths } from '../../../core/AppRouter/AppRouter';
import FormTextField from '../../../forms/FormTextField/FormTextField';

import './NewComment.scss';

const signinMsg = 'You need to sign in to be able to add a comment';
interface NewCommentProps {
    poll: PollRecord;
    setPoll: React.Dispatch<React.SetStateAction<PollRecord>>;
    comments: Comment[];
    setComments: React.Dispatch<React.SetStateAction<Comment[]>>;
}

const NewComment = (props: NewCommentProps): JSX.Element => {
    const { session } = useContext<SessionContextType>(SessionContext);
    const { setProcesses } = useContext<ProcessesContextType>(ProcessesContext);
    const navigate = useNavigate();
    const { userActivity, setUserActivity } =
        useContext<UserActivityContextType>(UserActivityContext);

    const onSubmitHandler = async (values: any, form: any): Promise<void> => {
        const result = await CommentAPI.create(
            {
                pollId: props.poll.id,
                text: values.text,
            },
            session,
        );

        if (result.id && form.reset) {
            form.reset();
            props.setComments([result as Comment, ...props.comments]);

            // Update poll comments count +1
            props.setPoll({ ...props.poll, comments: props.poll.comments + 1 });

            if (userActivity.activitySince > 0) {
                setUserActivity({
                    ...userActivity,
                    comments: userActivity.comments + 1,
                });
            }
        }
    };

    const onFocusHandler = () => {
        if (!session.user) {
            setProcesses({ redirect: '/', signinMsg });
            navigate(RoutePaths.SignIn);
        }
    };

    return (
        <Form
            onSubmit={onSubmitHandler}
            render={({ handleSubmit, values, form }) => (
                <form onSubmit={handleSubmit} className='new-comment-form'>
                    <FormTextField
                        name='text'
                        label='Write a comment...'
                        fullWidth
                        minRows={1}
                        multiline={true}
                        maxRows={10}
                        onFocus={onFocusHandler}
                    />
                    {values.text !== undefined && values.text !== '' && (
                        <Button onClick={() => onSubmitHandler(values, form)}>
                            Submit
                        </Button>
                    )}
                </form>
            )}
        />
    );
};

export default NewComment;
